import { AxiosInstance } from 'axios';
import { QuickMenuRequestModel } from '../models/Settings/ApplicationSettings/QuickMenuModel';

export interface WhoamiHotelModel {
  name: string;
  url: string;
  image: string | undefined;
  id: number;
}

export interface UserModel {
  avatar?: string;
  email: string;
  first_name: string;
  last_name: string;
  permissions: Array<string>;
  has_pin: boolean;
  is_inactive: boolean;
  quick_menu: QuickMenuRequestModel[];
}

export interface WhoamiModel {
  chain: string;
  hotels: WhoamiHotelModel[];
  user: UserModel;
  token: string | null;
  quickMenu: {
    icon: string;
    label: string;
    slug: string;
  }[];
}

export const whoami = (axios: AxiosInstance) => async (): Promise<WhoamiModel | null> => {
  return await axios
    .get('/whoami')
    .then(({ data }) => {
      return data;
    })
    .catch(error => {
      if (error?.response?.status === 302) {
        throw error;
      }
      const newError = new Error('Redirect') as any;
      newError.response = {
        status: 302,
        statusText: 'Found',
        data: error.response?.data || 'Redirect',
        headers: error.response?.headers || {},
        config: error.config,
      };
      throw newError;
    });
};

export const ping = (axios: AxiosInstance) => async (): Promise<{ pong: boolean } | null> => {
  return await axios.get('/ping');
};
